module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg0Mi4zIDU4NGExNiAxNiAwIDAgMC0xMC44LTQuMkg2NzUuOHYtNDgwYTMyIDMyIDAgMCAwLTMyLTMyaC0yNTZhMzIgMzIgMCAwIDAtMzIgMzJ2NDgwSDIwMC4yYTE2IDE2IDAgMCAwLTExLjggMjYuOGwzMTUuNiAzNDQuM2ExNiAxNiAwIDAgMCAyMi42IDFsMS0xIDMxNS42LTM0NC4zYTE2IDE2IDAgMCAwLTEtMjIuNnoiIGZpbGw9IiMwIiBwLWlkPSIzMjkzIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Arrow-down-filled.svg
// module id = 2L6l
// module chunks = 73